import { removeFromStorage } from "@/utils/secureStore";
import { useIsFocused } from "@react-navigation/native";
import * as Sentry from "@sentry/react-native";
import { useEffect } from "react";
import { Platform } from "react-native";

const useStorageReset = () => {
  const isFocused = useIsFocused();

  useEffect(() => {
    if (isFocused) {
      const removeDataAfterFlow = async () => {
        try {
          const keysToRemove = [
            "licensePlate",
            "receiptID",
            "isPurchasingPass",
            "stripe_session_id",
            "stripe_session_id_paid",
            "lastPurchasePass",
            "lastPay",
            "lastPassRedeem",
          ];

          for (const key of keysToRemove) {
            await removeFromStorage(key);
          }
        } catch (error) {
          console.error("Error while cleaning storage:", error);
          Sentry.captureException(error, {
            extra: {
              localStorage: Platform.OS === "web" ? window.localStorage : null,
            },
          });
        }
      };

      removeDataAfterFlow();
    }
  }, [isFocused]);
};

export default useStorageReset;
